module.exports = __webpack_public_path__ + "static/media/banner.f43920d3.png";